import { ODSDIAGNOSISENDPOINT, ODSCLIENTNAME } from '../FeedbackConstants';
import { OdsDiagnosisRequest } from '../schema/OdsDiagnosisRequest';

export default function addDiagnosticsToOdsSession(
    odsDiagnosisRequest: OdsDiagnosisRequest,
    token: any,
    diagnosticsSessionId: string
): Promise<Response> {
    let headers = new Headers();
    headers.append('Content-Type', 'application/json; charset=utf-8');
    headers.append('Authorization', `Bearer ${token}`);
    headers.append('Client-Name', ODSCLIENTNAME);
    headers.append('SaraSessionId', diagnosticsSessionId);

    let requestInit: RequestInit = {
        method: 'POST',
        credentials: 'omit',
    };

    requestInit.body = JSON.stringify(odsDiagnosisRequest);
    requestInit.headers = headers;

    return fetch(ODSDIAGNOSISENDPOINT, requestInit);
}
